import * as React from "react";
const SvgPoll = (props) => /* @__PURE__ */ React.createElement("svg", { className: "MuiSvgIcon-root jss3959", focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z" }));
export default SvgPoll;
